import { Brick, registerBrick, Query, ErrorFlow } from 'olympe';

export default class BuildCMUpdateSQLQuery extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} tableName
     * @param {string} toUpdate
     * @param {string} toDelete
     * @param {string} toInsert
     * @param {function()} forwardEvent
     * @param {function(string)} setQuery
     * @param {function(string)} setBindings
     */
    update($, [tableName, toUpdate = [], toDelete, toInsert = []], [forwardEvent, setQuery, setBindings, setErrorFlow]) {

        try {
            let paramIndex = 0;
            const bindings = {};

            const toUpdateMerged = [...(Array.isArray(toDelete) ? toDelete : []), ...(Array.isArray(toUpdate) ? toUpdate : [])];

            const insertItemsCount = toInsert?.length || 0; 
            const updateItemsCount = toUpdateMerged?.length || 0;

            const mapper = Query.instancesOf("0187b1d7be2a34856c46", false, "server")
                .executeFromCache()
                .reduce((acc, curr) => {
                const column = curr.get("0185c081050d996c424c");
                const field = curr.get("0185c081098c285960d8");
                acc[field] = `${column}`

                return acc;
            }, {});

            const createBindings = ({ value }) => {
                const newParam = `p${paramIndex}`;
                const binding = `:${newParam}`;
                bindings[newParam] = value;
                paramIndex++;
                return binding;
            };

            const fieldToColumn = (key) => mapper[key];

            const removeIfNotInMapper = (obj) => {
                for (const key in obj) {
                    const column = fieldToColumn(key);
                    if (column) {
                        const newBinding = createBindings({ value: obj[key] });
                        obj[column] = newBinding;
                        if(column!==key) delete obj[key];
                    } else {
                        delete obj[key];
                    }
                }
                return obj;
            };

            const generateInsertQuery = ({ tableName, data }) => {
                const cleanedData = removeIfNotInMapper(data);
                // Extract column names and values from the data object
                const columns = Object.keys(cleanedData);

                const values = Object.values(cleanedData).map((value) => {
                    if (typeof value === "string") {
                        // Escape single quotes by replacing each ' with ''
                        return `'${value.replace(/'/g, "''")}'`;
                    } else if (value === null) {
                        return "NULL";
                    } else {
                        return value;
                    }
                });

                // Join columns and values into comma-separated strings
                const columnsString = columns.join(", ");
                const valuesString = values.join(", ");

                // Construct the INSERT query
                return `INSERT INTO ${tableName} (${columnsString}) VALUES (${valuesString});`;
            };

            const generateUpdateQuery = ({ tableName, data }) => {
                const conditions = {
                cost_model_key: data.item,
                };

                const cleanedData = removeIfNotInMapper(data);

                // Create an array of updates from the data object
                const updates = Object.keys(cleanedData)
                    .map((key) => {
                        const value = cleanedData[key];
                        if (typeof value === "string") {
                        // Escape single quotes in the value
                        return `${key} = '${value.replace(/'/g, "''")}'`;
                        } else if (value === null) {
                        return `${key} = NULL`;
                        } else {
                        return `${key} = ${value}`;
                        }
                    })
                    .join(", ");

                // Create the condition string from the conditions object
                const conditionStrings = Object.keys(conditions)
                    .map((key) => {
                        const value = conditions[key];
                        if (typeof value === "string") {
                        // Escape single quotes in the condition value
                        return `${key} = '${value.replace(/'/g, "''")}'`;
                        } else if (value === null) {
                        return `${key} IS NULL`;
                        } else {
                        return `${key} = ${value}`;
                        }
                    })
                    .join(" AND ");

                // Construct the UPDATE query
                return `UPDATE ${tableName} SET ${updates} WHERE ${conditionStrings};`;
            };

            const insertQueries = insertItemsCount > 0 ? toInsert
                .map((item) => generateInsertQuery({ tableName, data: item }))
                .join(" ") : '';

            const updateQueries = updateItemsCount > 0 ? toUpdateMerged
                .map((item) => generateUpdateQuery({ tableName, data: item }))
                .join(" ") : '';

            let pattern = /':p(\d+)'/g;

            const cleansedInsertQueries = insertQueries.replace(pattern, ":p$1");
            const cleansedUpdateQueries = updateQueries.replace(pattern, ":p$1");
          
            const finalQuery = `${insertItemsCount > 0 ? cleansedInsertQueries : ""} ${updateItemsCount > 0 ? cleansedUpdateQueries : ""}`
  
            setQuery(finalQuery);
            setBindings(bindings)
            forwardEvent();

        } catch (error) {

            setErrorFlow(ErrorFlow.create(`Error ${error} during the execution`));

        }
    
    }
}

registerBrick('018ef62385e436dce5f1', BuildCMUpdateSQLQuery);